import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  getAIConversations,
  updateAiConversation
} from '../../actions';
import { FerrisWheelSpinner } from 'react-spinner-overlay';
import { BsTrash, BsEye, BsBoxArrowUpRight, BsArrowUp, BsArrowDown } from "react-icons/bs";
import {
  Button,
  Container,
  Row,
  Col,
  Table,
  Form
} from "react-bootstrap";
import toast, { Toaster } from 'react-hot-toast';
import K3ConversationViewModal from './K3ConversationViewModal';

class K3ConversationList extends Component {
  constructor(props) {
    super();
    this.state = {
      aiConversations: [],
      isLoading: true,
      showQuickView: false,
      selectedConversationId: null,
      sortField: 'create_time',
      sortDirection: 'desc',
      selectedConversations: new Set()
    };
  }

  componentDidMount() {
    this.props.getAIConversations();
  }

  componentWillReceiveProps(props) {
    this.setState({
      aiConversations: props.aiConversations,
      isLoading: false
    });
  }

  handleDeleteConversation = async (conversation) => {
    if (window.confirm(`Are you sure you want to delete conversation "${conversation.title}"?`)) {
      try {
        await this.props.updateAiConversation({
          _id: conversation._id,
          is_deleted: true
        });
        toast.success('Conversation deleted successfully');
        // Refresh list
        this.props.getAIConversations();
      } catch (error) {
        console.error('Error deleting conversation:', error);
        toast.error('Failed to delete conversation');
      }
    }
  };

  handleQuickView = (conversationId) => {
    this.setState({
      showQuickView: true,
      selectedConversationId: conversationId
    });
  };

  handleCloseQuickView = () => {
    this.setState({
      showQuickView: false,
      selectedConversationId: null
    });
  };

  handleOpen = (conversationId) => {
    window.open(`/v1/k3pl-chat?conversationId=${conversationId}`, '_blank');
  };

  handleSort = (field) => {
    const { sortField, sortDirection } = this.state;
    const newDirection = field === sortField && sortDirection === 'asc' ? 'desc' : 'asc';
    
    this.setState({
      sortField: field,
      sortDirection: newDirection
    });
  }

  renderSortIcon = (field) => {
    const { sortField, sortDirection } = this.state;
    if (field !== sortField) return null;
    return sortDirection === 'asc' ? <BsArrowUp /> : <BsArrowDown />;
  }

  handleSelectConversation = (conversationId) => {
    const { selectedConversations } = this.state;
    const newSelected = new Set(selectedConversations);
    
    if (newSelected.has(conversationId)) {
      newSelected.delete(conversationId);
    } else {
      newSelected.add(conversationId);
    }
    
    this.setState({ selectedConversations: newSelected });
  }

  handleSelectAll = () => {
    const { conversations } = this.props;
    const { selectedConversations } = this.state;
    
    if (selectedConversations.size === conversations.length) {
      this.setState({ selectedConversations: new Set() });
    } else {
      const allIds = conversations.map(con => con.conversation_id);
      this.setState({ selectedConversations: new Set(allIds) });
    }
  }

  handleDeleteSelected = () => {
    const { selectedConversations } = this.state;
    const { aiConversations } = this.props;
    
    if (selectedConversations.size === 0) return;
    
    if (window.confirm(`Are you sure you want to delete ${selectedConversations.size} selected conversations?`)) {
      selectedConversations.forEach(conversationId => {
        const conversation = aiConversations.find(con => con.conversation_id === conversationId);
        if (conversation) {
          this.props.updateAiConversation({
            _id: conversation._id,
            is_deleted: true
          });
        }
      });
      this.setState({ selectedConversations: new Set() });
    }
  }

  render() {
    const { aiConversations, isLoading, showQuickView, selectedConversationId, sortField, sortDirection, selectedConversations } = this.state;

    const conversations = aiConversations.filter(con => !con.is_deleted);

    const sortedConversations = conversations.sort((a, b) => {
      let valueA, valueB;
      switch (sortField) {
        case 'create_time':
          valueA = a.create_time || 0;
          valueB = b.create_time || 0;
          break;
        case 'update_time':
          valueA = a.update_time || a.create_time || 0;
          valueB = b.update_time || b.create_time || 0;
          break;
        default:
          valueA = a[sortField];
          valueB = b[sortField];
      }
      return sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
    });

    return (
      <>
        <Toaster position="top-right" />
        <Container fluid className="paper-style">
          {isLoading && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1000
            }}>
              <FerrisWheelSpinner loading={true} color="#17a2b8" />
            </div>
          )}

          <Row className="mt-3">
            <Col>
              <h3>Conversations</h3>
              <div className="d-flex justify-content-between align-items-center" style={{ height: '4rem' }}>
                <div>
                  <Form.Check
                    type="checkbox"
                    label="Select All"
                    checked={selectedConversations.size === conversations.length}
                    onChange={this.handleSelectAll}
                    className="d-inline-block me-3"
                  />
                  <span className="me-3">
                    {selectedConversations.size} selected
                  </span>
                </div>
                <div className="text-muted">
                  {conversations.length === 0
                    ? 'No conversations found'
                    : `Found ${conversations.length} ${conversations.length === 1 ? 'conversation' : 'conversations'}`}
                </div>
                {selectedConversations.size > 0 && (
                  <div className="">
                    <Button
                      variant="danger"
                      onClick={this.handleDeleteSelected}
                  >
                      Delete Selected
                    </Button>
                  </div>
                )}
              </div>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>ID</th>
                    <th>Title</th>
                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('create_time')}>
                      Created At {this.renderSortIcon('create_time')}
                    </th>
                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('update_time')}>
                      Updated At {this.renderSortIcon('update_time')}
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedConversations.map((conversation) => (
                    <tr key={conversation._id}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedConversations.has(conversation.conversation_id)}
                          onChange={() => this.handleSelectConversation(conversation.conversation_id)}
                          className="checkbox-center"
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '0.5rem',
                            margin: '0',
                            height: '100%'
                          }}
                        />
                      </td>
                      <td>{conversation.conversation_id}</td>
                      <td>{conversation.title}</td>
                      <td>{moment(conversation.create_time * 1000).format("YY-MM-DD HH:mm:ss")}</td>
                      <td>{moment(conversation.update_time * 1000).format("YY-MM-DD HH:mm:ss")}</td>
                      <td>
                        <Button
                          variant="link"
                          className="btn-icon"
                          onClick={() => this.handleQuickView(conversation.conversation_id)}
                          title="Quick View"
                        >
                          <BsEye />
                        </Button>
                        <Button
                          variant="link"
                          className="btn-icon"
                          onClick={() => this.handleDeleteConversation(conversation)}
                          title="Delete"
                        >
                          <BsTrash />
                        </Button>
                        <Button
                          variant="link"
                          className="btn-icon"
                          onClick={() => this.handleOpen(conversation.conversation_id)}
                          title="Open in new tab"
                        >
                          <BsBoxArrowUpRight />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>

          <K3ConversationViewModal
            show={showQuickView}
            onHide={this.handleCloseQuickView}
            conversationId={selectedConversationId}
          />
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    aiConversations: state.aiConversationReducer.aiConversations
  }
}

export default connect(mapStateToProps, {
  getAIConversations,
  updateAiConversation
})(K3ConversationList);